export default {
	Move: {
		West: "←",
		East: "→",
		North: "↑",
		South: "↓",
		NorthWest: "↖",
		NorthEast: "↗",
		SouthEast: "↘",
		SouthWest: "↙"
	},
	Drag: {
		West: "⇠",
		East: "⇢",
		North: "⇡",
		South: "⇣"
	},
	Place: {
		Start: "👋",
		End: ""
	},
	Attack: "🔫",
	Comment: "#",
	Wait: "."
};
